import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Tooltip, AreaChart, Area } from "recharts";

const KpiCard = ({ label, value }) => (
  <div className="hs-card p-5">
    <div className="text-[11px] font-mono uppercase text-[#4B5563]">{label}</div>
    <div className="font-display font-extrabold text-4xl mt-2">{value}</div>
  </div>
);

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/overview").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-sm text-[#4B5563]">Loading…</div>;

  return (
    <div data-testid="analytics-page" className="space-y-6">
      <div>
        <h1 className="font-display font-extrabold text-3xl">Analytics</h1>
        <p className="text-sm text-[#4B5563]">Performance across every channel.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard label="Agents" value={data.kpis.agents} />
        <KpiCard label="Conversations" value={data.kpis.conversations} />
        <KpiCard label="Calls" value={data.kpis.calls} />
        <KpiCard label="Leads" value={data.kpis.leads} />
      </div>
      <div className="hs-card p-6">
        <div className="font-display font-bold mb-3">Conversations vs Calls (7d)</div>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data.series} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
              <CartesianGrid stroke="#E2E8F0" vertical={false} />
              <XAxis dataKey="date" tick={{ fill: "#4B5563", fontSize: 11 }} />
              <YAxis tick={{ fill: "#4B5563", fontSize: 11 }} />
              <Tooltip />
              <Area type="monotone" dataKey="conversations" stroke="#0044FF" fill="#0044FF" fillOpacity={0.15} />
              <Area type="monotone" dataKey="calls" stroke="#030712" fill="#030712" fillOpacity={0.08} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
